{
  "header": {
    "title": "Survey templates",
    "description": "Browse and customize pre-built survey templates to quickly gather meaningful employee insights"
  },
  "tabs": {
    "chirpeeTemplates": "Chirpee templates",
    "companyTemplates": "Company templates",
    "myTemplates": "My templates"
  },
  "searchInput": {
    "placeholder": "Search templates"
  },
  "sortDropdown": {
    "triggerLabel": "Sort by",
    "options": {
      "questionQuantity": "Question quantity",
      "fromNewestToOldest": "From newest to oldest",
      "fromOldestToNewest": "From oldest to newest"
    }
  }
}
